<template>
  <div>
    <div class="professor" v-for="(professor, index) in professores">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <img :src="requireFoto(professor.foto)" :alt="`Foto do professor ${professor.nome}`"/>
          <div>
            <p>{{professor.nome}}</p>
            <p>{{translateCargo(professor)}}</p>
          </div>
        </div>
        <b-link v-b-toggle="'collapse-prof-' + id + '-' + index" class="btn btn-secondary">
          <i class="fas fa-list-ul mr-1"></i> ver currículo
        </b-link>
      </div>
      <b-collapse :id="'collapse-prof-' + id + '-' + index" class="mini-curriculo">
        <p class="curriculo-professor" v-html="professor.curriculo"></p>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import ImageUtils from '@/core/utils/image-utils'

export default {
  name: 'Professor',
  props: {
    professores: Array
  },
  data () {
    return {
      id: null
    }
  },
  mounted () {
    this.id = this._uid
  },
  methods: {
    isCoordenador: professor => professor.coordenador && (professor.coordenador === '1' || professor.coordenador === 1),

    isCoordenadorEProfessor: professor => professor.coordenadorEProfessor && (professor.coordenadorEProfessor === '1' || professor.coordenadorEProfessor === 1),

    translateCargo: function (professor) {
      if (this.isCoordenadorEProfessor(professor)) {
        return 'Coordenador e Professor'
      } else if (this.isCoordenador(professor)) {
        return 'Coordenador'
      }

      return 'Professor'
    },

    requireFoto: foto => ImageUtils.obterUrlCompletaImagem(`${foto}`, 'professor/')
  }
}
</script>

<style scoped>
</style>
